export const defaultRoute = "/";

export const otherRoutes = {
  info: "/info",
  publications: "/publications",
  research: "/research",
  contact: "/contact"
};
